module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pw-666cd05f03955ea01aa5859d914a0fa1.svg";